import { Box, Typography } from "@mui/material";

/**
 * MedidorInput - Componente de barra de progresso customizada
 */

interface MedidorInputProps {
  percentualUsado: number;
  percentualDisponivel: number;
  corUsado?: string;
  corDisponivel?: string;
}

function MedidorInput({
  percentualUsado,
  percentualDisponivel,
  corUsado = "#FF9800",
  corDisponivel = "#2196F3"
}: MedidorInputProps) {
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '32px',
            borderRadius: '4px',
            overflow: 'hidden',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}
        >
          {/* Parte Usada */}
          <Box
            sx={{
              width: `${percentualUsado}%`,
              backgroundColor: corUsado,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'width 0.3s ease'
            }}
          >
            {percentualUsado > 5 && (
              <Typography
                variant="body2"
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '13px'
                }}
              >
                {percentualUsado}%
              </Typography>
            )}
          </Box>

          {/* Parte Disponível */}
          <Box
            sx={{
              width: `${percentualDisponivel}%`,
              backgroundColor: corDisponivel,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'width 0.3s ease'
            }}
          >
            {percentualDisponivel > 5 && (
              <Typography
                variant="body2"
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '13px'
                }}
              >
                {percentualDisponivel}%
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default MedidorInput;